import { render, staticRenderFns } from "./TrackerRegisterHeader.vue?vue&type=template&id=c5344cb2&scoped=true"
import script from "./TrackerRegisterHeader.vue?vue&type=script&lang=ts"
export * from "./TrackerRegisterHeader.vue?vue&type=script&lang=ts"
import style0 from "./TrackerRegisterHeader.vue?vue&type=style&index=0&id=c5344cb2&prod&scoped=true&lang=scss"
import style1 from "./TrackerRegisterHeader.vue?vue&type=style&index=1&id=c5344cb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5344cb2",
  null
  
)

export default component.exports